"use client";

import { Button } from "@/components/ui/button";

export function PrintButton() {
  return (
    <Button variant="outline" onClick={() => window.print()} data-faro-user-action-name="print-resume" className="print:hidden">
      Print
    </Button>
  );
}
